import {styled, SxProps} from '@mui/material/styles';
import MuiRadio, {RadioProps as MuiRadioProps} from '@mui/material/Radio';
import {
  RadioSelected,
  HiristRadioSelected,
  RadioUnSelected,
  SurveyOptionSelected,
  SurveyOptionUnselected,
} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {FormControlLabel} from '@mui/material';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const IconImage = styled(Image)(({theme}) => ({
  '.Mui-focusVisible &': {
    outline: '2px auto',
    outlineColor: theme.palette.primary.light,
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: 'transparent',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    // cursor: 'not-allowed !important',
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(57,75,89,.5)'
        : 'rgba(206,217,224,.5)',
  },
}));
type MuiRadioPropsModified = Omit<MuiRadioProps, 'size'>;
interface RadioProps extends MuiRadioPropsModified {
  size?: number;
  label?: any;
  formSx?: SxProps;
  labelPlacement?: 'start' | 'end' | 'top' | 'bottom';
  variant?: 'default' | 'survey';
}
function Radio({
  size,
  label,
  sx,
  formSx,
  labelPlacement = 'end',
  variant = 'default',
  ...props
}: RadioProps) {
  return (
    <FormControlLabel
      control={
        <MuiRadio
          sx={{
            '&:hover': {bgcolor: 'transparent'},
            ...sx,
          }}
          disableRipple
          color="default"
          checkedIcon={
            <Image
              width={size ?? 20}
              height={size ?? 20}
              src={
                variant === 'survey'
                  ? SurveyOptionSelected
                  : isAppIimjobs
                    ? RadioSelected
                    : HiristRadioSelected
              }
              alt="RadiocheckedIcon"
            />
          }
          icon={
            <IconImage
              width={size ?? 20}
              height={size ?? 20}
              src={
                variant === 'survey' ? SurveyOptionUnselected : RadioUnSelected
              }
              alt="RadioUnCheckIcon"
            />
          }
          {...props}
        />
      }
      label={label}
      labelPlacement={labelPlacement}
      sx={{width: 'fit-content', ...formSx}}
    />
  );
}

export default Radio;
